
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(94),
  playerId: Number.withConstraint(x => x >= 0),
  sessionId: Number.withConstraint(x => x >= 0),
  sessionTime: Number,
  inGameState: String.withConstraint(x => x.length <= 64),
  level: Number.withConstraint(x => x >= 0 && x <= 256),
  minFps: Number.withConstraint(x => x >= 0 && x <= 256),
  maxFps: Number.withConstraint(x => x >= 0 && x <= 256),
  fps: Always,
  measurementDuration: Number.withConstraint(x => x >= 0 && x <= 65535),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  animations: String.withConstraint(x => x.length <= 64),
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  connectionType: String.withConstraint(x => x.length <= 10),
  memoryUsage: Number.withConstraint(x => x >= 0 && x <= 65536),
  buildVersion: Number.withConstraint(x => x >= 0 && x <= 4294967295),
}).And(Partial({
  deviceType: String.withConstraint(x => x.length <= 255),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(94),
  playerId: Number.withConstraint(x => x >= 0),
  sessionId: Number.withConstraint(x => x >= 0),
  sessionTime: Number,
  inGameState: String.withConstraint(x => x.length <= 64),
  level: Number.withConstraint(x => x >= 0 && x <= 256),
  minFps: Number.withConstraint(x => x >= 0 && x <= 256),
  maxFps: Number.withConstraint(x => x >= 0 && x <= 256),
  fps: Always,
  measurementDuration: Number.withConstraint(x => x >= 0 && x <= 65535),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  animations: String.withConstraint(x => x.length <= 64),
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  connectionType: String.withConstraint(x => x.length <= 10),
  memoryUsage: Number.withConstraint(x => x >= 0 && x <= 65536),
  buildVersion: Number.withConstraint(x => x >= 0 && x <= 4294967295),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  lang: String.withConstraint(x => x.length <= 5),
  accountId: String.withConstraint(x => x.length <= 30),
}).And(Partial({
  deviceType: String.withConstraint(x => x.length <= 255),
  zoneId: Number.withConstraint(x => x >= 0),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 94;
  